import React from "react";

function cn(...classes) {
  return classes.filter(Boolean).join(" ");
}

const variants = {
  primary:
    "border-sky-600 bg-sky-600 text-white hover:bg-sky-700 hover:border-sky-700 shadow-sky-500/20",
  secondary:
    "border-slate-200 bg-white text-slate-700 hover:bg-slate-50 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200 dark:hover:bg-slate-800",
  dark:
    "border-slate-900 bg-slate-900 text-white hover:bg-slate-950 dark:border-white dark:bg-white dark:text-slate-950 dark:hover:bg-slate-100",
  white:
    "border-white bg-white text-sky-700 hover:bg-sky-50 hover:text-sky-800 shadow-white/20",
  soft:
    "border-sky-100 bg-sky-50 text-sky-700 hover:bg-sky-100 dark:border-sky-500/20 dark:bg-sky-500/10 dark:text-sky-300 dark:hover:bg-sky-500/20",
  danger:
    "border-rose-600 bg-rose-600 text-white hover:bg-rose-700 hover:border-rose-700 shadow-rose-500/20",
  dangerSoft:
    "border-rose-200 bg-rose-50 text-rose-700 hover:bg-rose-100 dark:border-rose-500/20 dark:bg-rose-500/10 dark:text-rose-300 dark:hover:bg-rose-500/20",
  ghost:
    "border-transparent bg-transparent text-slate-600 hover:bg-slate-100 dark:text-slate-300 dark:hover:bg-slate-800",
};

const sizes = {
  sm: "min-h-10 rounded-2xl px-3 py-2 text-xs",
  md: "min-h-11 rounded-2xl px-4 py-2.5 text-sm",
  lg: "min-h-12 rounded-[1.25rem] px-5 py-3 text-sm",
};

export default function AdminButton({
  type = "button",
  variant = "secondary",
  size = "md",
  icon: Icon,
  rightIcon: RightIcon,
  children,
  loading = false,
  disabled = false,
  className = "",
  ...props
}) {
  return (
    <button
      type={type}
      disabled={disabled || loading}
      className={cn(
        "inline-flex items-center justify-center gap-2 border font-bold shadow-sm transition active:scale-[0.98] disabled:cursor-not-allowed disabled:opacity-60",
        variants[variant] || variants.secondary,
        sizes[size] || sizes.md,
        className,
      )}
      {...props}
    >
      {loading ? (
        <span className="h-4 w-4 animate-spin rounded-full border-2 border-current border-t-transparent" />
      ) : Icon ? (
        <Icon />
      ) : null}

      {children ? <span>{children}</span> : null}

      {RightIcon ? <RightIcon /> : null}
    </button>
  );
}